(() => {
	const initSlider = (section) => {
		let collectionsSlider;

		if (document.currentScript) {
			collectionsSlider = document.currentScript.parentElement.querySelectorAll(
				".js-slider-collections-slider"
			);
		} else {
			collectionsSlider = section.querySelectorAll(
				".js-slider-collections-slider"
			);
		}

		if (collectionsSlider && collectionsSlider.length > 0) {
			collectionsSlider.forEach((el) => {
				const speed1 = el.getAttribute("data-duration");
				const prevBtn = section.querySelector(".swiper-button-prev");
				const nextBtn = section.querySelector(".swiper-button-next");
				const scrollbarTrackEl = section.querySelector(".swiper-scrollbar-nav__track");
				const showProgressbar = el.getAttribute("data-progressbar") === "true";

				const maxSlots = Number(el.getAttribute("data-column-count"));
				const slideEls = el.querySelectorAll(".swiper-slide");
				const wrapperEl = el.querySelector(".swiper-wrapper");

				if (maxSlots > 0 && slideEls.length > 0 && wrapperEl) {
					const slideWidth = slideEls[0].getBoundingClientRect().width;
					const gap = parseFloat(getComputedStyle(wrapperEl).columnGap) || 0;
					el.style.maxWidth = `${maxSlots * slideWidth + (maxSlots - 1) * gap}px`;
				} else {
					el.style.maxWidth = "";
				}

				const logosSwiper1 = new Swiper(el, {
					slidesPerView: "auto",
					spaceBetween: 16,
					autoplay: false,
					direction: "horizontal",
					loop: false,
					speed: speed1,
					shortSwipes: true,
					longSwipes: true,
					allowTouchMove: true,
					watchOverflow: true,
					centerInsufficientSlides: true,
					navigation:
						prevBtn && nextBtn ? { nextEl: nextBtn, prevEl: prevBtn } : false,
					pagination:
						showProgressbar && scrollbarTrackEl
							? { el: scrollbarTrackEl, type: "progressbar" }
							: false,
					breakpoints: {
						576: {
							spaceBetween: 16,
						},
						990: {
							spaceBetween: 20,
						},
						1150: {
							spaceBetween: 20,
						},
						1250: {
							spaceBetween: 20,
						},
					},
					mousewheel: {
						forceToAxis: true,
					},
				});
			});
		}
	};

	const initSection = (section) => {
		let sectionCollections;

		if (document.currentScript) {
			sectionCollections = document.currentScript.parentElement;
		} else {
			sectionCollections = section;
		}

		const sectionResizeObserver = new ResizeObserver((entries) => {
			const [entry] = entries;
			const sliders = entry.target.querySelectorAll(
				".js-slider-collections-slider"
			);
			const slidersSlow = entry.target.querySelectorAll(
				".js-slider-collections-slider-slow"
			);

			if (sliders.length != 0) {
				sliders.forEach((slider) => {
					if (slider.swiper) slider.swiper.destroy();
				});
			}

			if (slidersSlow.length != 0) {
				slidersSlow.forEach((slider) => {
					if (slider.swiper) slider.swiper.destroy();
				});
			}

			initSlider(sectionCollections);
		});

		initSlider(sectionCollections);

		sectionResizeObserver.observe(sectionCollections);
	};

	initSection();

	document.addEventListener("shopify:section:load", function (section) {
		initSection(section.target);
	});
})();
